export function setAuthToken(token: string) {
  localStorage.setItem('token', token);
}
export function getAuthToken() {
  return localStorage.getItem('token');
}
export function deleteAuthToken() {
  return localStorage.removeItem('token');
}
export function setRefreshToken(refresh: string) {
  localStorage.setItem('refresh', refresh);
}
export function getRefreshToken() {
  return localStorage.getItem('refresh');
}
export function deleteRefreshToken() {
  return localStorage.removeItem('refresh');
}
